var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAnonymization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 17.25V15.4167C14.666 14.4442 14.2797 13.5116 13.5921 12.8239C12.9044 12.1363 11.9718 11.75 10.9993 11.75H4.58268C3.61022 11.75 2.67759 12.1363 1.98996 12.8239C1.30232 13.5116 0.916016 14.4442 0.916016 15.4167V17.25M16.4994 5.33333L21.0827 9.91667M21.0827 5.33333L16.4994 9.91667M11.4577 4.41667C11.4577 6.44171 9.81606 8.08333 7.79102 8.08333C5.76597 8.08333 4.12435 6.44171 4.12435 4.41667C4.12435 2.39162 5.76597 0.75 7.79102 0.75C9.81606 0.75 11.4577 2.39162 11.4577 4.41667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnonymization);
export default __webpack_public_path__ + "static/media/icon-anonymization.1cf546e10722f3c6a3cb1ed202dddebf.svg";
export { ForwardRef as ReactComponent };